var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEntireCatalog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M9 38h62v32a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M47 71V39M50 71V39M53 71V39M56 71V39M59 71V39M62 71V39M65 71V39M68 71V39"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m47 38 4.833-11.76a2 2 0 0 1 1.85-1.24h19.333a2 2 0 0 1 1.85 2.76L70.658 38M35 38l-5.362-11.826A2 2 0 0 0 27.816 25H6.103a2 2 0 0 0-1.822 2.826L8.895 38"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M40 17V4M47.006 20.071l9.04-9.04M33.034 20.071l-9.04-9.04"
})));
export default SvgEntireCatalog;